function getUpdatedQuizCode(quizHtml) {
    // Check for utm_medium=email parameter (case-insensitive)
    const urlParams = new URLSearchParams(window.location.search);
    const utm = urlParams.get('utm_medium');
    if (utm && utm.toLowerCase() === 'email' || Electro.LOGGED_IN === true) {
        // Add skipemail parameter to iframe src if utm_medium=email or we're logged in
        const pattern = /(<iframe[^>]+src="[^"]*\?)([^"]*)"/i;
        const replacement = `$1skipemail=true&$2"`;
        return quizHtml.replace(pattern, replacement);
    }
    return quizHtml;
}
export default class Quiz {
    constructor() {
        if (Electro.DEBUG) {
            console.info('Quiz.constructor()');
        }

        this.quiz = Electro.QUIZ;
    }

    init() {
        if (Electro.DEBUG) {
            console.info('Quiz.init()');
        }

        this.quiz = getUpdatedQuizCode(this.quiz);

        const hash = window.location.hash;
        if (hash === '#quiz') {
            const quizPanel = document.querySelector('.panel--scent-quiz');
            if (quizPanel) {
                setTimeout(() => {
                    const quizPanelTop = quizPanel.getBoundingClientRect().top;
                    const scrollDistance = quizPanelTop - 62;
                    window.scrollBy({top: scrollDistance, left: 0, behavior: 'smooth'});
                }, 500);
            }
        }

        const quizButtons = document.querySelectorAll(".js-scent-quiz");
        quizButtons.forEach((quizButton) => {
            quizButton.addEventListener('click', () => {
                const quizContainer = quizButton.parentNode.parentNode.parentNode.parentNode;
                quizContainer.innerHTML = this.quiz;
            });
        });
    }
}
